import { bindable, autoinject, transient, ViewEngine, Container, PLATFORM } from "aurelia-framework";

@autoinject
@transient()
export class RightshipCompTooltip {

    public compTooltipContext: RightshipCompTooltip = this;
    public dropdown: string;
    isDropdownOpen: boolean = false;

    @bindable
    public on: HTMLElement;

    @bindable
    public position: string = 'top';

    private onEnter = () => {
        this.isDropdownOpen = true;
    };

    constructor(private element: Element, private viewEngine: ViewEngine) {
    }

    private onLeave = (event) => {
        if (event.relatedTarget && event.relatedTarget.className != "comp-tooltip-wrap") {
            this.isDropdownOpen = false;
        } else {
            $(event.relatedTarget).mouseleave(this.onLeave);
        }
    };

    attached() {
        this.viewEngine.loadViewFactory(PLATFORM.moduleName('views/components/rightship-comp-tooltip/rightship-comp-tooltip-dropdown.html')).then(response => {
            const dropdown = response.create(Container.instance);
            const view = (<any>this.element).au.controller.view;
            const slot = view.hasSlots ? view.slots["__au-default-slot-key__"].children[0].outerHTML : "";
            this.dropdown = (<any>dropdown.fragment.childNodes[1]).outerHTML.replace("<inner-html></inner-html>", slot).replace(/au-target-id="\d*"/g, "").replace(/au-target/g, "");

            if (this.on) {
                this.on.addEventListener("mouseenter", this.onEnter);
                this.on.addEventListener("mouseleave", this.onLeave);
            }
        });
    }

    detached() {
        if (this.on) {
            this.on.removeEventListener("mouseenter", this.onEnter);
            this.on.removeEventListener("mouseleave", this.onLeave);
        }
    }

    get left() {
        const rect = this.element.getBoundingClientRect();
        if (rect.left < 0)
            return rect.left * -1;
        const right = window.innerWidth - rect.right;
        if (right < 0)
            return right;
        return 0;
    }
}